import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/invoices")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Invoices</div>
        <div className="page-subtitle">View and manage invoices</div>
      </div>
    </>
  ),
});
